//@ts-check
//Reviewed
import React, { useState, useEffect } from 'react';
import { TreeSelectView, MultiSelect } from '../../_shared';
import cx from 'classnames';
import { folderWorkflowService } from './folderWorkflow.service';
import { store } from '../../../_helpers';
import { alertActions } from '../../App';

const FolderWorkflowAdd = ({
    filteredTreeData,
    workflows,
    onAdd,
    existingConfigs
}) => {
    const [selectedFolder, setSelectedFolder] = useState({ label: '', value: '' });
    const [selectedWorkflow, setSelectedWorkflow] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [workflowStatuses, setWorkflowStatuses] = useState([]);
    const [folderPath, setFolderPath] = useState('');
    const [validationMessage, setValidationMessage] = useState('');

    useEffect(() => {
        if (!selectedWorkflow) {
            setWorkflowStatuses([]);
            setSelectedStatus(null);
            return;
        }

        const workflow = workflows.find((w) => w.id === selectedWorkflow.id);
        if (workflow && workflow.statuses) {
            const statusOptions = workflow.statuses
                .filter((s) => s.enabled)
                .map((s) => ({
                    label: s.label || s.name,
                    value: s.id,
                    id: s.id,
                    ...s
                }));
            setWorkflowStatuses(statusOptions);
        } else {
            setWorkflowStatuses([]);
        }
        setSelectedStatus(null);
    }, [selectedWorkflow]);


    const findFolder = (treeData, key) => {
        if (!treeData) return null;
        for (const node of treeData) {
            if (node.key === key) return node;
        }
        return null;
    };

    const onNodeSelect = (node) => {
        setSelectedFolder(node);
        setValidationMessage('');

        const dir = findFolder(filteredTreeData, node.value);
        if (dir) {
            setFolderPath(dir.path || '');
        }
    };

    const onWorkflowChange = (option) => {
        setSelectedWorkflow(option);
        setValidationMessage('');
    };


    const onStatusChange = (option) => {
        setSelectedStatus(option);
        setValidationMessage('');
    };

    const validate = async () => {
        
        if (!selectedFolder || !selectedFolder.value) {
            setValidationMessage('Please select a folder');
            return false;
        }

        store.dispatch(alertActions.loading(true));
        var { isValid, message } = await folderWorkflowService.validation({
            directoryId: selectedFolder.value,
            directoryPath: folderPath,
            workflowId: selectedWorkflow.id,
            workflowStatusId: selectedStatus.id,
        });
        store.dispatch(alertActions.loading(false));

        if (isValid === false) {
            setValidationMessage(message);
            return false;
        }

        if (!selectedWorkflow) {
            setValidationMessage('Please select a workflow');
            return false;
        }

        if (!selectedStatus) {
            setValidationMessage('Please select a default workflow status');
            return false;
        }
        return true;
    };

    const handleAdd = async () => {
        if (!await validate()) return;

        await onAdd({
            directoryId: selectedFolder.value,
            directoryName: selectedFolder.label,
            directoryPath: folderPath,
            workflowId: selectedWorkflow.id,
            workflowName: selectedWorkflow.name || selectedWorkflow.label,
            workflowStatusId: selectedStatus.id,
            workflowStatusName: selectedStatus.label || selectedStatus.name
        });

        // Reset form
        setSelectedFolder({ label: '', value: '' });
        setSelectedWorkflow(null);
        setSelectedStatus(null);
        setFolderPath('');
        setValidationMessage('');
    };

    return (
        <>
            <div className="folder-workflow-form-row">
                <div className="folder-workflow-field">
                    <span>Folder</span>
                    <TreeSelectView
                        treeData={filteredTreeData}
                        selectedValue={selectedFolder}
                        onNodeSelect={onNodeSelect}
                        placeholder={'Select Folder'}
                        dropdownClassName="folder-workflow-dropdown"
                    />
                </div>

                <div className="folder-workflow-field">
                    <span>Default Workflow</span>
                    <MultiSelect
                        isMulti={false}
                        options={workflows}
                        selectedOptions={selectedWorkflow ? [selectedWorkflow] : []}
                        onChange={onWorkflowChange}
                        closeMenuOnSelect={true}
                        placeholder="Select Workflow"
                    />
                </div>

                <div className="folder-workflow-field">
                    <span>Default Status</span>
                    <MultiSelect
                        isMulti={false}
                        options={workflowStatuses}
                        selectedOptions={selectedStatus ? [selectedStatus] : []}
                        onChange={onStatusChange}
                        closeMenuOnSelect={true}
                        placeholder="Select Status"
                    />
                </div>

                <button
                    className={cx('mrnda-btn', {
                        'authorization-disabled':
                            !selectedFolder?.value || !selectedWorkflow || !selectedStatus
                    })}
                    onClick={handleAdd}>
                    Add
                </button>
            </div>

            {validationMessage && (
                <div className="help-block" style={{ padding: '8px 0 0' }}>
                    {validationMessage}
                </div>
            )}
        </>
    );
};

export { FolderWorkflowAdd };
